import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'pre-register',
    loadChildren: () => import('./pre-register/pre-register.module').then((m) => m.PreRegisterModule),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardPageModule),
  },
  {
    path: 'devolution-list',
    loadChildren: () => import('./devolution-list/devolution-list.module').then(m => m.DevolutionListPageModule)
  },
  {
    path: 'devolution-resume',
    loadChildren: () => import('./devolution-resume/devolution-resume.module').then(m => m.DevolutionResumePageModule)
  },
  {
    path: 'scheduling-list',
    loadChildren: () => import('./scheduling-list/scheduling-list.module').then(m => m.SchedulingListPageModule)
  },
  {
    path: 'favorites-pix',
    loadChildren: () => import('./favorites-pix/favorites-pix.module').then(m => m.FavoritesPixPageModule)
  },
  {
    path: 'manual-transfer',
    loadChildren: () => import('./manual-transfer/manual-transfer.module').then(m => m.ManualTransferPageModule)
  },
  {
    path: 'manage-keys',
    loadChildren: () => import('./manage-keys/manage-keys.module').then((m) => m.ManageKeysPageModule),
  },
  {
    path: 'register-key-pix',
    loadChildren: () => import('./register-key/register-key-pix.module').then((m) => m.PixRegisterKeyModule),
  },
  {
    path: 'key-transaction',
    loadChildren: () => import('./key-transaction/key-transaction.module').then((m) => m.KeyTransactionPageModule),
  },
  {
    path: 'prepare-transaction',
    loadChildren: () => import('./prepare-transaction/prepare-transaction.module').then((m) => m.PrepareTransactionPageModule),
  },
  {
    path: 'claim-keys',
    loadChildren: () => import('./claim-keys/claim-keys.module').then((m) => m.ClaimkeysPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PixRoutingModule { }
